export default __webpack_public_path__ + "static/media/no_post_icon_video.1445df8e.png";